import { IDataSet } from "./interfaces";
import { dateToTimestamp } from "./utils";
import http from "./http-common";

export const getData = async (dateFrom: Date | undefined, dateTo: Date | undefined, datasetsIds: Array<string>) => {
  const fromTimestamp = dateToTimestamp(dateFrom);
  const toTimestamp = dateToTimestamp(dateTo);
  const apiUrl = "/EASAS/rest/datasetData/dataInfoRange?";
  const url: string = apiUrl + "from=" + fromTimestamp + "&to=" + toTimestamp; //new URLSearchParams({ from: dateFrom?.toISOString(), to: dateTo?.toISOString() } as any)

  const getDataFromApi = async (datasetsIdsJson: string) => {
    const res: any = http
      .post(url, datasetsIdsJson)
      .then((res) => {
        return createIDataSetArr(res.data);
      })
      .catch((err) => {
        _handleError(err);
      });
    return await res;
  };

  let datasetsIdsJson;
  if (datasetsIds?.length !== 0) {
    datasetsIdsJson = JSON.stringify(datasetsIds);
    const resultsFromApi = await getDataFromApi(datasetsIdsJson)
    return resultsFromApi;
  } else return null;
};

const createIDataSet = (data: any): IDataSet => {
  const dataSet: IDataSet = {
    data: data.data,
    identifier: data.identifier,
    title: data.title,
    unit: data.unit,
  };
  return dataSet;
};

const createIDataSetArr = (data: any): Array<IDataSet> => {
  const iDataSetArr: Array<IDataSet> = data.map((d: any) => {
    return createIDataSet(d);
  });
  return iDataSetArr;
};

function _handleError(error: any) {
  console.log("Error while Fetching data from server, error:" + error.message);
}
